import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";

function List(props) {
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const columns = [
    {
      name: "First Name",
      selector: (row) => row.firstName,
    },
    {
      name: "Last Name",
      selector: (row) => row.lastName,
    },
    {
      name: "Email",
      selector: (row) => row.email,
    },
    {
      name: "Status",
      selector: (row) => (row.isActive == "1" ? "Active" : "inActive"),
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          {utils.hasPermission(primaryMenuRes, "User", "user.edit") && (
            <RB.Button
              className="btn-circle"
              variant="outline-primary"
              size="sm"
              onClick={handelEdit(row)}
            >
              <EditIcon />
            </RB.Button>
          )}
          &nbsp;
          {console.log(row?.user_role[0]?.id)}
          {row?.user_role[0]?.roleName !== "Super Admin"
            ? utils.hasPermission(primaryMenuRes, "User", "user.delete") && (
                <RB.Button
                  className="btn-circle"
                  variant="outline-danger"
                  size="sm"
                  onClick={showDelete(row)}
                >
                  <Delete />
                </RB.Button>
              )
            : ""}
        </>
      ),
      omit:
        !utils.hasPermission(primaryMenuRes, "User", "user.edit") &&
        !utils.hasPermission(primaryMenuRes, "User", "user.delete"),
    },
  ];

  useEffect(() => {
    getUserList();
  }, [page]);

  const getUserList = () => {
    utils
      .callAPI("get", `/users/users-list?page=${page}&per_page=${countPerPage}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setUserList(res);
        } else {
          setUserList([]);
        }
      })
      .catch((err) => {
        setUserList([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/users/users-delete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getUserList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        {/* <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            {utils.hasPermission(primaryMenuRes, "User", "user.create") && (
              <RB.Button
                className="btn btn-primary me-2"
                onClick={handleAddClick}
              >
                Add User
              </RB.Button>
            )}
          </div>
        </RB.Card.Header> */}
        <RB.Card.Body>
          <DataTable
            columns={columns}
            data={userList.result}
            highlightOnHover
            responsive
            pagination
            paginationServer
            paginationTotalRows={userList.total}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            striped
            onChangePage={(page) => setPage(page)}
            persistTableHead
            customStyles={{
              head: {
                style: {
                  fontSize: "0.875rem", // Adjust the font size as needed
                  fontWeight: "bold", // Adjust the font weight as needed
                },
              },
            }}
            // subHeader
            // subHeaderComponent={subHeaderComponent}
          />
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
